/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { InputBoxWithoutSuggestion } from '../shared-component/inputBoxWithoutSuggestion';
// import { makeApi, URLS } from 'Utils/apiUtil';

const LeadName = props => {
  const suggestionKey = 'name';
  const [inputVal, setInputVal] = React.useState('');

  return (
    <div className="input-section lead-name">
      <InputBoxWithoutSuggestion
        inputVal={inputVal}
        placeholder="Contact Name"
        setInputVal={setInputVal}
        suggestionKey={suggestionKey}
        {...props}
      />
    </div>
  );
};

export { LeadName };
export default LeadName;
